import * as Behavior from "./Behavior";
import * as Types from "./Types";

export default class PathMover {
    constructor(path, options) {
        this._svgPath = path;
        this._totalPathLen = ~~(this._svgPath.getTotalLength());
        this._currentLen = 0;
        this._prevPercent = 0;

        this._width = options.width;
        this._height = options.height;

        this._updatePathBehavior = this.changeUpdatePathBehavior(options.updatePathBehavior);
        this._backwardDirectionBehavior = this.changeBackWardDirectionBehavior(options.backwardDirectionBehavior);
    }
    updatePath(value) {
        this._updatePathBehavior.updatePath(value);

        const POINT = this._svgPath.getPointAtLength(this._currentLen);
        const X = ~~(POINT.x - this._width / 2);
        const Y = ~~(POINT.y - this._height / 2);
        const PREV_POINT = this._svgPath.getPointAtLength(this._currentLen - 1);
        const X1 = POINT.y - PREV_POINT.y;
        const X2 = POINT.x - PREV_POINT.x;
        let angle = Math.atan(X1/X2)*(180/Math.PI);

        angle = this._checkNegativeAngle(angle);
        angle = this._calculateBakwardDirection(value, angle);

        this._prevPercent = value;

        return { x: X, y: Y, angle: angle};
    }

    changeUpdatePathBehavior(behaviorType) {
        switch(behaviorType) {
            case Types.UpdatePathBehaviorType.ByPercentage:
                return new Behavior.UpdatePathByPercentageBehavior(this);
            case Types.UpdatePathBehaviorType.ByConstantValue:
                return new Behavior.UpdatePathByConstantValueBehavior(this);
            default:
                return new Behavior.UpdatePathByConstantValueBehavior(this);
        }
    }

    changeBackWardDirectionBehavior(behaviorType) {
        switch(behaviorType) {
            case Types.BackwardDirectionBehaviorType.Calculate:
                return new Behavior.CalculateBackwardDirectionBehavior(this);
            case Types.BackwardDirectionBehaviorType.DontCalculate:
                return new Behavior.DontCalculateBackwardDirectionBehavior(this);
            default:
                return new Behavior.CalculateBackwardDirectionBehavior(this);
        }
    }

    _checkNegativeAngle(angle) {
        if(angle<0){
            angle = angle+180;
        }

        return angle;
    }

    _calculateBakwardDirection(position, angle) {
        return this._backwardDirectionBehavior.calculateBakwardDirection(position, angle);
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/PathMover/PathMover.js